import React from "react";
import clsx from "clsx";
import { Message as IMessage } from "Models/message";
import Message from "./Message";
import { PRODUCER_BUFFER_SIZE } from "Components/constants";
import useDelayedValue from "hooks/useDelayedValue";
import styles from "./Buffer.module.css";

type BufferProps = {
    recentMessage?: IMessage;
    delay?: number;
};

const Buffer = ({ recentMessage, delay = 0 }: BufferProps) => {
    const delayedShift = useDelayedValue(
        (recentMessage?.id ?? 0) + 1,
        !!recentMessage ? delay : 0,
        0
    );

    const buffer = React.useMemo(
        () =>
            Array.from({ length: PRODUCER_BUFFER_SIZE }, (_, idx) => {
                const messageId = (recentMessage?.id ?? 0) + idx + 1;
                return {
                    id: messageId,
                    value: messageId.toString(),
                    tick: (recentMessage?.tick ?? 0) + idx + 1,
                    partitionId: -1,
                    uid: messageId.toString(),
                    originUid: null,
                };
            }),
        [recentMessage]
    );

    return (
        <div
            className={clsx(styles.root, { [styles.animate]: !!recentMessage })}
            style={{
                transform: `translateX(calc(-60px * ${delayedShift}))`,
                left: `calc(60px * ${recentMessage?.id ?? 1})`,
            }}
        >
            {buffer.map((m) => (
                <Message key={m.uid} message={m} />
            ))}
        </div>
    );
};

export default Buffer;
